export const translations = {
  ar: {
    nav: {
      features: "المميزات",
      how: "آلية العمل",
      pricing: "الأسعار",
      faq: "الأسئلة",
      login: "تسجيل الدخول",
      cta: "ابدأ تجربتك المجانية",
      langLabel: "EN",
    },
    hero: {
      badge: "مصنوع في عُمان · لشركات الخليج",
      title_a: "اجمع كل رسائل عملائك",
      title_b: "في شاشة واحدة،",
      title_c: "وزد مبيعاتك بالذكاء الاصطناعي",
      subtitle:
        "سوشال هَب يربط واتساب وانستقرام وفيسبوك والبريد الإلكتروني في صندوق رسائل واحد. أتمتة الردود، تعاون فريق المبيعات، وتقارير مبيعات لحظية — كل ذلك بواجهة عربية أصيلة.",
      cta_primary: "ابدأ تجربتك المجانية",
      cta_secondary: "شاهد جولة المنصة",
      trust: "بدون بطاقة ائتمان · إعداد خلال ٣ دقائق · إلغاء في أي وقت",
    },
    logos: {
      title: "تثق بنا فرق خدمة عملاء في أكثر من ٢٠٠ شركة عُمانية وخليجية",
    },
    stats: {
      response: "أسرع في الرد",
      response_v: "٣x",
      sales: "زيادة في المبيعات",
      sales_v: "+٤٢٪",
      messages: "رسالة شهرياً",
      messages_v: "+٢ مليون",
      uptime: "جاهزية المنصة",
      uptime_v: "٩٩.٩٪",
    },
    features: {
      overline: "كل ما تحتاجه فريق خدمة العملاء",
      title: "منصة واحدة. كل قنوات التواصل.",
      subtitle:
        "بدلاً من التنقل بين تطبيق وآخر، يُدير فريقك جميع المحادثات من شاشة واحدة بكفاءة وسرعة.",
      items: {
        inbox: {
          title: "صندوق رسائل موحّد",
          desc: "واتساب · انستقرام · فيسبوك · بريد إلكتروني · ويب شات — كل المحادثات تظهر في مكان واحد مع توزيع تلقائي على الموظفين.",
          tag: "متعدد القنوات",
        },
        ai: {
          title: "روبوت ذكاء اصطناعي بالعربية",
          desc: "يفهم لهجات الخليج، يجيب فوراً على الأسئلة المتكررة، ويحوّل المحادثة لموظف بشري عند الحاجة.",
          tag: "ذكاء اصطناعي",
        },
        whatsapp: {
          title: "ربط واتساب في ٣ دقائق",
          desc: "ربط رسمي عبر Meta Business بدون تعقيدات، مع رسائل القوالب والحملات الترويجية.",
          tag: "واتساب أعمال",
        },
        team: {
          title: "تعاون فريق العمل",
          desc: "ملاحظات داخلية، توزيع التذاكر، وحالة الموظف اللحظية لتعاون أسرع.",
          tag: "فِرق",
        },
        crm: {
          title: "إدارة العلاقات والعملاء",
          desc: "ملف كامل لكل عميل، تاريخ المحادثات، الطلبات، والمتابعات المجدولة.",
          tag: "CRM",
        },
      },
    },
    how: {
      overline: "ابدأ خلال دقائق",
      title: "كيف يعمل سوشال هَب؟",
      subtitle:
        "ثلاث خطوات بسيطة لتحويل خدمة عملائك من فوضى إلى نظام احترافي.",
      steps: {
        s1: {
          n: "١",
          title: "سجّل حسابك",
          desc: "أنشئ حساب سوشال هَب الخاص بشركتك خلال أقل من دقيقة. اختر الباقة المناسبة، وابدأ تجربتك المجانية فوراً.",
        },
        s2: {
          n: "٢",
          title: "اربط قنواتك",
          desc: "اربط واتساب أعمال، انستقرام، فيسبوك، والبريد الإلكتروني بنقرات بسيطة وبدون أي تعقيدات تقنية.",
        },
        s3: {
          n: "٣",
          title: "ابدأ الرد",
          desc: "دع فريقك يتعامل مع جميع رسائل العملاء من شاشة واحدة، ودَع الذكاء الاصطناعي يتولى الباقي.",
        },
      },
    },
    pricing: {
      overline: "أسعار شفافة · بالريال العُماني",
      title: "اختر الباقة المناسبة لحجم فريقك",
      subtitle:
        "كل الباقات تشمل صندوق رسائل موحّد وتقارير لحظية. بدون رسوم خفية.",
      monthly: "شهرياً",
      currency: "ر.ع",
      mostPopular: "الأكثر طلباً",
      plans: {
        growth: {
          name: "النمو",
          desc: "للشركات الناشئة وفرق الدعم الصغيرة",
          price: "٣٥",
          features: [
            "٣ مستخدمين",
            "ربط واتساب + انستقرام + فيسبوك",
            "صندوق رسائل موحّد",
            "تقارير أساسية",
            "دعم فني بالعربية",
          ],
          cta: "ابدأ مجاناً",
        },
        pro: {
          name: "المحترف",
          desc: "للشركات النامية التي تحتاج أتمتة",
          price: "٧٥",
          features: [
            "١٠ مستخدمين",
            "جميع القنوات + البريد الإلكتروني",
            "ردود تلقائية وقواعد ذكية",
            "تقارير متقدمة وتحليلات",
            "حملات رسائل ترويجية",
            "دعم أولوية ٢٤/٧",
          ],
          cta: "ابدأ تجربتك",
        },
        enterprise: {
          name: "المؤسسات",
          desc: "للشركات الكبيرة والمتاجر الكبرى",
          price: "١٥٠+",
          features: [
            "مستخدمون غير محدودين",
            "روبوت ذكاء اصطناعي بالعربية",
            "تكامل CRM مخصّص",
            "API كامل ومخصص",
            "مدير حساب مخصّص",
            "اتفاقية مستوى خدمة SLA",
          ],
          cta: "تواصل مع المبيعات",
        },
      },
      credits: {
        title: "رصيد الرسائل الترويجية",
        desc: "بالإضافة إلى باقتك، يمكنك شراء رصيد رسائل ترويجية للحملات التسويقية عبر واتساب بنظام الدفع حسب الاستخدام.",
        cta: "اطلب عرض أسعار",
      },
    },
    testimonials: {
      overline: "قصص نجاح حقيقية",
      title: "ماذا يقول عملاؤنا؟",
      items: [
        {
          quote:
            "وفّر علينا سوشال هَب ساعات يومياً. قبل كنّا نفقد رسائل في انستقرام، الآن كل شيء منظّم وفريقي يجاوب أسرع بثلاث مرات.",
          name: "أحمد البلوشي",
          role: "مدير المبيعات، متاجر الواحة",
        },
        {
          quote:
            "الذكاء الاصطناعي بالعربية فعلاً يفهم العملاء. زادت تحويلات المبيعات من واتساب عندنا ٤٠٪ في شهرين فقط.",
          name: "نورا الكندي",
          role: "مؤسسة، بوتيك نور",
        },
        {
          quote:
            "أبسط منصة جربتها. الإعداد أخذ مني ١٠ دقائق، والدعم الفني العُماني فاهم احتياجات السوق.",
          name: "سالم الحارثي",
          role: "مدير عمليات، كوفي لاب",
        },
      ],
    },
    faq: {
      overline: "أسئلة شائعة",
      title: "كل ما تحتاج معرفته",
      items: [
        {
          q: "هل أحتاج معرفة تقنية لاستخدام سوشال هَب؟",
          a: "لا أبداً. المنصة مصمّمة لأصحاب الأعمال وفرق المبيعات. الإعداد يتم بنقرات بسيطة، وفريق الدعم الفني العُماني متاح لمساعدتك في أي وقت.",
        },
        {
          q: "كيف يتم ربط واتساب أعمال؟",
          a: "نستخدم الربط الرسمي عبر Meta Business Platform. الربط يأخذ ٣ دقائق فقط، وستحصل على رقم واتساب موثّق بالعلامة الخضراء جاهز للحملات الترويجية والردود التلقائية.",
        },
        {
          q: "هل بياناتي ومحادثات عملائي آمنة؟",
          a: "نعم. جميع البيانات مشفّرة، ومستضافة على خوادم عُمانية. نلتزم بمعايير حماية البيانات العالمية ولا نشارك بياناتك مع أي طرف ثالث.",
        },
        {
          q: "هل يمكنني الإلغاء في أي وقت؟",
          a: "بالتأكيد. لا توجد عقود سنوية إجبارية. يمكنك ترقية، تخفيض، أو إلغاء اشتراكك في أي وقت من لوحة التحكم.",
        },
        {
          q: "ما الذي يجعل سوشال هَب أفضل من Freshworks أو Respond؟",
          a: "نحن مبنيون لسوق الخليج: واجهة عربية كاملة، أسعار بالريال العُماني، دعم فني محلي، وروبوت ذكاء اصطناعي يفهم لهجات الخليج. الخدمات العالمية صُمّمت لأسواق أخرى.",
        },
        {
          q: "هل يمكنني تجربة المنصة مجاناً؟",
          a: "نعم، تجربة مجانية ١٤ يوم على باقة المحترف بدون بطاقة ائتمان. تجرّب كل المميزات وتقرّر براحتك.",
        },
      ],
    },
    cta: {
      title: "جاهز تحوّل خدمة عملائك لمستوى جديد؟",
      subtitle:
        "انضم لمئات الشركات الخليجية التي تستخدم سوشال هَب لإدارة محادثات عملائها بكفاءة.",
      primary: "ابدأ تجربتك المجانية",
      secondary: "تحدث مع المبيعات",
    },
    footer: {
      tagline: "صندوق رسائل موحّد لشركات الخليج. مصنوع في عُمان.",
      product: "المنتج",
      company: "الشركة",
      legal: "قانوني",
      contact: "تواصل معنا",
      links: {
        features: "المميزات",
        pricing: "الأسعار",
        integrations: "التكاملات",
        about: "من نحن",
        blog: "المدونة",
        careers: "وظائف",
        privacy: "سياسة الخصوصية",
        terms: "الشروط والأحكام",
        cookies: "ملفات الارتباط",
        dataDeletion: "حذف البيانات",
      },
      rights: "جميع الحقوق محفوظة.",
      address: "مسقط، سلطنة عُمان",
    },
  },
  en: {
    nav: {
      features: "Features",
      how: "How it works",
      pricing: "Pricing",
      faq: "FAQ",
      login: "Log in",
      cta: "Start free trial",
      langLabel: "ع",
    },
    hero: {
      badge: "Made in Oman · Built for the Gulf",
      title_a: "Unify all your customer messages",
      title_b: "in one screen,",
      title_c: "and grow sales with AI.",
      subtitle:
        "SocialHub connects WhatsApp, Instagram, Facebook and Email into a single inbox. Automate replies, collaborate with your sales team, and get real-time reports — all with a native Arabic interface.",
      cta_primary: "Start your free trial",
      cta_secondary: "Watch product tour",
      trust: "No credit card · 3-minute setup · Cancel anytime",
    },
    logos: {
      title: "Trusted by 200+ customer service teams across the GCC",
    },
    stats: {
      response: "Faster replies",
      response_v: "3x",
      sales: "Sales lift",
      sales_v: "+42%",
      messages: "Messages/month",
      messages_v: "+2M",
      uptime: "Platform uptime",
      uptime_v: "99.9%",
    },
    features: {
      overline: "Everything your support team needs",
      title: "One platform. Every channel.",
      subtitle:
        "Instead of juggling apps, your team handles all conversations from a single screen with speed and efficiency.",
      items: {
        inbox: {
          title: "Unified inbox",
          desc: "WhatsApp · Instagram · Facebook · Email · Web chat — every conversation in one place with smart agent routing.",
          tag: "Omnichannel",
        },
        ai: {
          title: "Arabic-native AI bot",
          desc: "Understands Gulf dialects, instantly answers FAQs, and hands off to humans when needed.",
          tag: "AI",
        },
        whatsapp: {
          title: "WhatsApp in 3 minutes",
          desc: "Official Meta Business onboarding, message templates, and broadcast campaigns.",
          tag: "WhatsApp Business",
        },
        team: {
          title: "Team collaboration",
          desc: "Internal notes, ticket routing, and live agent status for faster teamwork.",
          tag: "Teams",
        },
        crm: {
          title: "CRM & contacts",
          desc: "Full customer profile, conversation history, orders, and scheduled follow-ups.",
          tag: "CRM",
        },
      },
    },
    how: {
      overline: "Get started in minutes",
      title: "How SocialHub works",
      subtitle:
        "Three simple steps to turn your customer service from chaos into a system.",
      steps: {
        s1: {
          n: "1",
          title: "Sign up",
          desc: "Create your SocialHub workspace in under a minute. Pick a plan and start your free trial instantly.",
        },
        s2: {
          n: "2",
          title: "Connect channels",
          desc: "Connect WhatsApp Business, Instagram, Facebook, and Email with a few clicks — no technical setup.",
        },
        s3: {
          n: "3",
          title: "Start replying",
          desc: "Let your team handle every customer message from one screen, while AI handles the rest.",
        },
      },
    },
    pricing: {
      overline: "Transparent pricing · in OMR",
      title: "Pick the plan that fits your team",
      subtitle:
        "All plans include a unified inbox and live reports. No hidden fees.",
      monthly: "/ month",
      currency: "OMR",
      mostPopular: "Most popular",
      plans: {
        growth: {
          name: "Growth",
          desc: "For startups and small support teams",
          price: "35",
          features: [
            "3 users",
            "WhatsApp + Instagram + Facebook",
            "Unified inbox",
            "Basic reports",
            "Arabic support",
          ],
          cta: "Start free",
        },
        pro: {
          name: "Pro",
          desc: "For growing businesses that need automation",
          price: "75",
          features: [
            "10 users",
            "All channels + Email",
            "Auto-replies & smart rules",
            "Advanced analytics",
            "Promotional campaigns",
            "Priority 24/7 support",
          ],
          cta: "Start trial",
        },
        enterprise: {
          name: "Enterprise",
          desc: "For large companies and major retailers",
          price: "150+",
          features: [
            "Unlimited users",
            "Arabic-native AI bot",
            "Custom CRM integration",
            "Full custom API",
            "Dedicated account manager",
            "SLA agreement",
          ],
          cta: "Contact sales",
        },
      },
      credits: {
        title: "Promotional message credits",
        desc: "On top of your plan, buy WhatsApp promotional message credits on pay-as-you-go pricing for marketing campaigns.",
        cta: "Request quote",
      },
    },
    testimonials: {
      overline: "Real success stories",
      title: "What our customers say",
      items: [
        {
          quote:
            "SocialHub saves us hours daily. We used to lose Instagram messages — now everything is organized and my team replies 3x faster.",
          name: "Ahmed Al-Balushi",
          role: "Sales Manager, Al-Waha Stores",
        },
        {
          quote:
            "The Arabic AI actually understands customers. WhatsApp sales conversions are up 40% in just two months.",
          name: "Noora Al-Kindi",
          role: "Founder, Noor Boutique",
        },
        {
          quote:
            "The simplest platform I've tried. Setup took 10 minutes and the Omani support team really gets the market.",
          name: "Salim Al-Harthi",
          role: "Operations Lead, Coffee Lab",
        },
      ],
    },
    faq: {
      overline: "Frequently asked",
      title: "Everything you need to know",
      items: [
        {
          q: "Do I need technical knowledge to use SocialHub?",
          a: "Not at all. The platform is designed for business owners and sales teams. Setup is a few clicks, and our Omani support team is always there to help.",
        },
        {
          q: "How is WhatsApp Business connected?",
          a: "We use the official Meta Business Platform integration. The connection takes only 3 minutes and you'll get a green-checkmark WhatsApp number ready for promotional campaigns and auto-replies.",
        },
        {
          q: "Are my data and customer chats secure?",
          a: "Yes. All data is encrypted and hosted on Omani servers. We comply with global data protection standards and never share your data with third parties.",
        },
        {
          q: "Can I cancel anytime?",
          a: "Absolutely. No mandatory annual contracts. Upgrade, downgrade, or cancel anytime from your dashboard.",
        },
        {
          q: "What makes SocialHub better than Freshworks or Respond?",
          a: "We're built for the Gulf market: full Arabic interface, OMR pricing, local support, and an AI bot that understands Gulf dialects. Global tools were designed for other markets.",
        },
        {
          q: "Can I try the platform for free?",
          a: "Yes — a 14-day free trial on the Pro plan with no credit card required. Try every feature and decide at your own pace.",
        },
      ],
    },
    cta: {
      title: "Ready to level up your customer service?",
      subtitle:
        "Join hundreds of GCC businesses using SocialHub to manage customer conversations efficiently.",
      primary: "Start your free trial",
      secondary: "Talk to sales",
    },
    footer: {
      tagline: "A unified inbox for Gulf businesses. Made in Oman.",
      product: "Product",
      company: "Company",
      legal: "Legal",
      contact: "Contact",
      links: {
        features: "Features",
        pricing: "Pricing",
        integrations: "Integrations",
        about: "About",
        blog: "Blog",
        careers: "Careers",
        privacy: "Privacy Policy",
        terms: "Terms of Service",
        cookies: "Cookies",
        dataDeletion: "Data Deletion",
      },
      rights: "All rights reserved.",
      address: "Muscat, Sultanate of Oman",
    },
  },
};
